<template>
	<div class="wrapper">
		<breadcrumbs></breadcrumbs>
		<div class="wrappers">
			<div class="mn">
				<div class="zhanzhuai-main-top box mb15 p25 cl">
					<div class="zz_forum_wrap cl">
						<div class="forumicn cl">
							<img src="../../../assets/forum.gif" alt="">
						</div>
						<div class="zz_forum_text cl">
							<div class="zhanzhuai-lists-txt">
								<div class="zhanzhuai_forumtitle">{{title}}</div>
								<div class="zhanzhuai_foruminfo">
									收录了 {{total}} 篇文章
								</div>
							</div>
						</div>
<!-- 						<div class="zhanzhuai-lists-hdc"  @click="handlecreate(1,'')">发布新帖</div> -->
					</div>
				</div>
				
				<div class="tl zz_default_list box mb15 bm bmw">
					<div class="th zz_th">
						<el-table
						  v-loading="loading"
						  :data="list"
						  fit
						  highlight-current-row
						  style="width: 100%;"
						>
						  <el-table-column label="标题" show-overflow-tooltip align="left">
						    <template slot-scope="scope">
						     <div class="wen" @click="detail(scope.row)">
					<!-- 			 //<img src="../../../assets/folder_new.gif" alt=""> -->
								 <span>{{scope.row.title}}
								    <span v-if="scope.row.jinghua==1" style="color:red;font-size: 12px;">
										精华帖
									</span>
								 </span>
							 </div>
						    </template>
						  </el-table-column>
						  <el-table-column label="作者" width="120" show-overflow-tooltip align="left">
						    <template slot-scope="scope">
						      <span class="hovers">{{scope.row.nickname}}</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="发布日期" width="180" show-overflow-tooltip align="left">
						    <template slot-scope="scope">
						      <span>{{scope.row.createTime}}</span>
						    </template>
						  </el-table-column>
<!-- 						  <el-table-column label="回复" width="100" show-overflow-tooltip align="center">
						    <template slot-scope="scope">
						      <span class="hovers">{{scope.row.pingnum}}</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="查看" width="100" show-overflow-tooltip align="center">
						    <template slot-scope="scope">
						      <span>{{scope.row.show}}</span>
						    </template>
						  </el-table-column> -->
						</el-table>
					</div>
				</div>
				<div class="pagination-container" style="margin-bottom: 30px;">
				  <el-pagination
				    :current-page="listQuery.page"
				    :page-sizes="[10,20, 30,40]"
				    :page-size="listQuery.limit"
				    :total="total"
				    background layout="total, sizes, prev, pager, next, jumper"
				    @size-change="handleSizeChange"
				    @current-change="handleCurrentChange"
				  />
				</div>
				<!--快速发帖-->
	<!-- 			<div class="zz_f_pst_wrap box mb15 p25 cl">
					<div class="zz_section_title cl">
						快速发帖
					</div>
				</div> -->
				<!--快速发帖-->
			</div>
			
			<div class="ri">
				<div class="zz_section_titles" @click="handlecreate(1,'')">
					发布新帖
				</div>
				<div class="zz_jspc_pdiy box p25">
					<div class="zz_section_title">
						热门专题
					</div>
					<div class="cl" style="display: flex;flex-wrap: wrap;">
						<div class="cls" v-for="(item,i) in zhuantiarr" @click="zhuanticlick(item)" :key="i">
							<span>
								{{item.title}}
							</span>
						</div>
					</div>
				</div>
				
				<div class="zz_jspc_pdiy box p25">
					<div class="zz_section_title" style="margin-bottom: 0px;">
						最新帖子
					</div>
					<div class="rewenlist" v-for="(item,i) in list" @click="detail(item)" v-if="i<5" :key="i">
				<!-- 		<div class="zz_express_pic">
							<img :src="" alt="">
						</div> -->
						<div class="zz_express_txt">
							<div class="hs">
								<div class="hss">
									{{item.title}}
								</div>
							</div>
							<span>{{item.createTime}}</span>
						</div>
					</div>
				</div>
				
				<div class="zz_jspc_pdiy box p25">
					<div class="zz_section_title">
						阅读推荐
					</div>
					<div class="yueduo">
						<div class="yueduos"  v-for="(item,i) in list" @click="detail(item)" v-if="i>5 && i<11" :key="i">
							<i></i>
							<div class="yueduos01">
								<div class="zz_recnews_title">{{item.title}}</div>
								<div class="zz_recnews_time">{{item.createTime}}</div>
							</div>
						</div>
					</div>
				</div>
				
			</div>
		</div>
		<save ref="savedata" @succ="succcreate"></save>
	</div>
</template>

<script>
	import { tiezi_list,zhuanti_list } from "@/api/boke"
	import save from "./components/save.vue"
		import { getToken } from '@/utils/auth'
	export default {
		components:{
			save
		},
		data(){
			return{
				list:[],
				total:0,
				loading:false,
				listQuery:{
					page:1,
					limit:10,
					zhuantiid:''
				},
				title:"",
				
				zhuantiarr:'',//专题arr
			}
		},
		mounted(){
			if(this.$route.query.zhuantiid){
				console.log("this.$route.query",this.$route.query);
				this.title = this.$route.query.title
				document.title = this.$route.query.title?this.$route.query.title:'帖子列表';
				this.listQuery.zhuantiid = this.$route.query.zhuantiid?this.$route.query.zhuantiid:'';
				this.tiezi_list();
				this.zhuanti_list();//第一主题
			}else{
				this.$message.error("缺少参数");
				setTimeout(()=>{
					this.$router.push({
						path:"/forum"
					})
				},2000)
			}
			 
		},
		created(){
			
		},
		methods:{
			handlecreate(type){
				//需要先判断一下是否登录
				if(getToken()){
					this.$refs.savedata.handlecreate(type,{zhuantiid:this.listQuery.zhuantiid},1);
				}else{
					loginEvent.$emit('loginDialogEvent')
				}
			},
			succcreate(){
				this.tiezi_list();
			},
			zhuanticlick(item){
				this.list = [];
				this.title = item.title
				document.title = item.title
				this.listQuery.zhuantiid = item.id
				this.listQuery.page = 1
				this.tiezi_list()
			},
			async tiezi_list(){
				this.loading = false
				await tiezi_list(this.listQuery).then(res=>{
					this.loading = false
					console.log("帖子列表",res.data);
					this.total = res.data.total
					this.list = res.data.list
				}).catch(()=>{
					this.loading = false
				})
			},
			detail(row){
				this.$router.push({
					path:'/forumdetail',
					query:{
						id:row.id
					}
				})
			},
			zhuanti_list(){
				zhuanti_list({}).then(res=>{
					console.log("专题列表",res.data);
					this.zhuantiarr = res.data
				}).catch(()=>{
					
				})
				 
			},
			//下一页上一页操作
			handleSizeChange(val) {//条数
			  this.listQuery.limit = val
			  this.tiezi_list()
			},
			handleCurrentChange(val) {//列数
			  this.listQuery.page = val
			  this.tiezi_list()
			},
		},
	}
</script>

<style lang="scss" scoped>
	.yunsss{
		background: #FFA07A!important;
		border-color: #FFA07A!important;
		color: #fff!important;
	}
	.zz_section_titles{
		width: 100%;
		    height: 50px;
		    line-height: 50px;
		    margin-bottom: 15px;
		    text-align: center;
		    border-radius: 4px;
		    background: #fc7247;
			color: #fff;
			font-size: 15px;
			text-align: center;
			cursor: pointer;
	}
	.yueduo{
		height: 390px;
		border-left: 1px solid #EEEEEE;
		.yueduos{
			position: relative;
	        padding: 6px 0 6px 15px;
			cursor: pointer;
			.yueduos01{
				line-height: 24px;
				color: #999;
				.zz_recnews_title{
					font-size: 14px;
					color: #333;
					overflow: hidden;
				}
				.zz_recnews_title:hover{
					color: #FFA07A;
				}
				.zz_recnews_time{
					margin-bottom: 10px;
					font-size: 14px;
					font-style: inherit;
					font-family: Georgia;
				}
			}
			i{
			    width: 5px;
			    height: 5px;
			    background: #fff;
			    border-width: 1px;
			    border-color: #aaa;
			    border-style: solid;
			    border-radius: 100%;
			    position: absolute;
			    z-index: 1;
			    left: -4px;
			    top: 15px;	
			}
		}
		.yueduos:hover{
			i{
				background: #FFA07A;
				border-color: #FFA07A;
			}
		}
	}
	.rewenlist:nth-child(1){
		padding: 0px;
	}
	.rewenlist{
		height: 65px;
		padding: 20px 0;
		border-bottom: 1px solid #f0f0f0;
		cursor: pointer;
		.zz_express_txt{
			cursor: pointer;
			    height: 65px;
			    overflow: hidden;
				span{
					font-size: 12px;
					    color: #8590a6;
				}
	
				.hs{
					margin-bottom: 8px;
					    max-height: 40px;
					    text-overflow: ellipsis;
					    overflow: hidden;
					    -webkit-line-clamp: 2;
					.hss{
						line-height: 20px;
						    font-size: 14px;
						    color: #18191a;
						    font-weight: 400;
						    word-break: break-word;
					}
					.hss:hover{
						color: #FFA07A;
					}
				}
		}
		.zz_express_pic{
			position: relative;
			    float: left;
			    width: 100px;
			    height: 65px;
			    margin-right: 12px;
			    overflow: hidden;
				img{
					width: 100px;
					    height: 65px;
					    vertical-align: top
				}
			span{
				position: absolute;
				    top: 0;
				    left: 0;
				    height: 20px;
				    padding: 0 10px;
				    color: #fff;
				    font-size: 12px;
				    line-height: 20px;
				    opacity: .85;
				    background-color: #313B3D;
				    border-radius: 2px 0 0;
			}
		}
	}
	.cls:nth-child(2n){
		margin-left: auto;
		margin-bottom: 10px;
	}
	.cls{
		    width: 132px;
		    overflow: hidden;
		span{
			    display: block;
			    height: 36px;
			    line-height: 36px;
			    font-size: 14px;
			    text-align: center;
			    background-color: #f5f6f7;
			    border: 1px solid #f0f0f0;
			    overflow: hidden;
				color: #333;
				cursor: pointer;
		}
		span:hover{
			background: #FFA07A;
			color: #fff;
			border: 1px solid #FFA07A;
		}
	}
	.zz_section_title{
		position: relative;
		height: 20px;
		line-height: 20px;
		margin-bottom: 20px;
		padding-bottom: 20px;
		font-size: 16px;
		color: #262626;
		font-weight: 400;
		border-bottom: 1px solid #f0f0f0;
		overflow: hidden;
	}
	.tl{
		.th{
			margin-top: 1px;
			border-bottom: 1px solid #f0f0f0;
			cursor: pointer;
			.wen{
			   display: flex;
			   align-items: center;
			   justify-content: center;
			   cursor: pointer;
			   img{
				   width: 17px;
				   height: 17px;
				   margin-right: 10px;
			   }
			}
			.hovers:hover{
				color: #FFA07A;
			}
			.wen:hover{
				color: #FFA07A;
			}
		}
	}
	.zhanzhuai-lists-hdc{
		margin-left: auto;
		width: 90px;
		height: 30px;
		line-height: 30px;
		border-radius: 40px;
		text-align: center;
		background: #72D072;
		border: 1px solid #72D072;
			font-size: 15px;
			color: #fff;
		cursor: pointer;
	}
	.zhanzhuai-lists-hdc:hover{
		background: #5EBC5E;
		border: 1px solid #5EBC5E;
	}
	.zz_forum_text{
		position: relative;
		padding-left: 28px;
		.zhanzhuai-lists-txt{
			padding-top: 8px;
			.zhanzhuai_forumtitle{
				display: inline;
				font-size: 21px;
				font-weight: 700;
				vertical-align: middle;
				color: #333;
				cursor: pointer;
			}
			.zhanzhuai_forumtitle:hover{
				color: #FFA07A;
			}
			.zhanzhuai_foruminfo{
				margin-top: 10px;
				font-size: 14px;
				color: #969696;
			}
		}
	}
	.zhanzhuai-main-top{
		.zz_forum_wrap{
			width: 100%;
			display: flex;
			align-items: center;
			.forumicn{
				width: 80px;
				    height: 80px;
				    border-radius: 50%;
					img{
						width: 100%;
						height: 100%;
					}
			}
		}
	}
	.wrapper{
		width: 1200px;
		margin: 0 auto;
		padding-top: 30px;
		.wrappers{
			width: 100%;
			display: flex;
			.mn{
				width: 860px;
				margin-bottom: 10px;
			}
			.ri{
				width: 325px;
				margin-left: auto;
				margin-bottom: 10px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/luntan/luntan/forumdisplay.vue